export class VisitsSelectionReuqest {
  // TODO: Move
  selectionName: string;
  take: number;
  orderBy: string; // Default will be "-time" from back-end if not set to any other

  constructor(selectionName: string, take: number) {
    this.selectionName = selectionName;
    this.take = take;
  }
}

export class InputSearchCriteria {
  // TODO: Move
  input: any;
  operator: number;
  type: string; // id or property name
  displayExp?: string;
}
